import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  imgSrc: string
  whiteImgSrc: string
  hasBullet?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  imgSrc,
  whiteImgSrc,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        <span className='menu-icon'>
          <img
            src={isActive ? whiteImgSrc : imgSrc}
            alt={title}
            className='menu-img'
            style={{ width: '24px', height: '24px', marginRight: '8px' }} // Adjust size and spacing
          />
        </span>
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}





export {SidebarMenuItem}
